module.exports = __webpack_public_path__ + "static/media/ep1.c3416a53.jpg";